export const exterior_view02ImageOptions = {
  angle: 'exterior_view02',
  staticOptions: {
    HullColorways: 1,
    BowSpirit: 1,
    HullTreatment: 1,
    Deck: 1,
    TeakOnSideDecks: 1,
    TeakOnCoachroof: 1,
    Sprayhood: 1,
    Wheel: 1,
    MastAndBoom: 1,
    BoomCover: 1,
    PedestalOptions: 1,
    BathingPlatform: 1
  },
  mattes: [
    {
      option: 'HullColorways',
      dependency: 'PedestalOptions'
    },
    {
      option: 'BowSpirit',
      dependency: 'HullColorways'
    },
    {
      option: 'Deck',
      dependency: 'BathingPlatform'
    },
    {
      option: 'TeakOnSideDecks',
      dependency: 'Deck'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/XP44/views/exterior_view02.js